<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar [user]="user" [title]="title" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>

<mat-card>
    <mat-card-title>Utenti attivi - inattivi</mat-card-title>
    <mat-card-subtitle>Tasso utenti inattivi per sottogruppi. Sono considerati pazienti inattivi:<br>
      <ul>
        <li style="font-weight: bold;">"TELEMEDICINA": non hanno effettuato il login per 4 mesi o più.</li>
        <li style="font-weight: bold;">"STANDARD": non hanno effettuato il login per 7 mesi o più.</li>
      </ul>    
      L'analisi è stata effettuata per i seguenti sottogruppi: 
    </mat-card-subtitle>
    <mat-card-content>
      <app-box-dashboard title="Globali" routerLink="/inactive-global-section" image="inactive.png"></app-box-dashboard>
      <app-box-dashboard title="Categoria" route="/inactive-category-section" image="options.png"></app-box-dashboard>
      <app-box-dashboard title="Patologia" route="/inactive-pathology-section" image="diagnosi.png"></app-box-dashboard>
      <app-box-dashboard title="Sesso" route="/inactive-sex-section" image="sesso.png"></app-box-dashboard>
      <app-box-dashboard title="Eta" route="/inactive-age-section" image="eta.png"></app-box-dashboard>
      <app-box-dashboard title="Eta alla diagnosi" route="/inactive-age-of-diagnosis-section" image="eta.png"></app-box-dashboard>
      <app-box-dashboard title="Durata malattia" route="/inactive-pathology-duration-section" image="eta.png"></app-box-dashboard>
      <app-box-dashboard title="Terapia attiva" route="/inactive-activetherapy-section" image="options.png"></app-box-dashboard>
      <app-box-dashboard title="Interventi" route="/inactive-interventi-section" image="interventi.png"></app-box-dashboard>
      <app-box-dashboard title="Malattia iniziale attiva" route="/inactive-malattia-iniziale-section" image="check.png"></app-box-dashboard>


  <div style="clear:both;"></div>
    </mat-card-content>
  </mat-card>
  <br>

  